import { gql } from '@apollo/client'

export default gql`
  mutation UpdatePlanetName($input: UpdatePlanetNameInput!) {
    updatePlanetName(input: $input)
  }
`
